import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { showErrorNotification } from '../actions/App';
import * as actions from '../actions/Drivers';
import * as driverApi from '../api/Drivers';
import * as usersApi from '../api/Users';
import {
  GET_CARRIER_DRIVER_LIST,
  GET_DRIVERS_BY_CARRIER_ID,
  CREATE_DRIVER,
  UPDATE_DRIVER,
  REMOVE_DRIVER,
} from '../constants/ActionTypes';

function* getCarrierDriverList({ payload }) {
  yield put(actions.setDriverListLoading(true));

  try {
    const { data } = yield call(driverApi.getDriversByCarrierId, payload.carrierId);

    yield put(actions.getDriverListSuccess({ entities: data, pageCount: 0 }));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }

  yield put(actions.setDriverListLoading(false));
}

function* getDriversByCarrierId({ payload }) {
  yield put(actions.setDriversByCarrierIdLoading(payload.carrierId, true));
  try {
    const { data } = yield call(driverApi.getDriversByCarrierId, payload.carrierId);
    yield put(actions.getDriversByCarrierIdSuccess(payload.carrierId, data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  } finally {
    yield put(actions.setDriversByCarrierIdLoading(payload.carrierId, false));
  }
}

function* createDriver({ payload }) {
  try {
    const { data } = yield call(
      driverApi.createDriver,
      payload.carrierId,
      payload.supervisor,
      payload.driver,
    );

    yield put(actions.createDriverSuccess(data));
  } catch (error) {
    yield put(actions.updateDriverFailure());
    yield put(showErrorNotification(error.messages));
  }
}

function* updateDriver({ payload }) {
  try {
    const { data } = yield call(
      driverApi.updateDriver,
      payload.carrierId,
      payload.driverId,
      payload.supervisor,
      payload.driver,
    );

    yield put(actions.updateDriverSuccess(data));
  } catch (error) {
    yield put(actions.updateDriverFailure());
    yield put(showErrorNotification(error.messages));
  }
}

function* removeDriver({ payload }) {
  const { driverId, supervisorId } = payload;
  try {
    yield call(driverApi.removeDriver, driverId);
    if (supervisorId) {
      yield call(usersApi.deleteUserById, supervisorId);
    }
    yield put(actions.removeDriverSuccess(payload.driverId));
  } catch (error) {
    yield put(actions.updateDriverFailure());
    yield put(showErrorNotification(error.messages));
  }
}

export function* getCarrierDriverListSaga() {
  yield takeEvery(GET_CARRIER_DRIVER_LIST, getCarrierDriverList);
}

export function* getDriversByCarrierIdSaga() {
  yield takeLatest(GET_DRIVERS_BY_CARRIER_ID, getDriversByCarrierId);
}

export function* createDriverSaga() {
  yield takeEvery(CREATE_DRIVER, createDriver);
}

export function* updateDriverSaga() {
  yield takeEvery(UPDATE_DRIVER, updateDriver);
}

export function* removeDriverSaga() {
  yield takeEvery(REMOVE_DRIVER, removeDriver);
}

export default function* rootSaga() {
  yield all([
    fork(getCarrierDriverListSaga),
    fork(getDriversByCarrierIdSaga),
    fork(createDriverSaga),
    fork(updateDriverSaga),
    fork(removeDriverSaga),
  ]);
}
